import type { RGBA } from "@/domain/share";

export const BLACK: RGBA = { r: 0, g: 0, b: 0, a: 1 };
